module.exports = {
  materialData: () => {
    return {
      "TUCSON HEV LIMITED": {

        "BASIC_DEFAULT":{
          "type": "basic",
          "enable": false,
          "color": 0xFFFFFF,
          "reflectivity": 1,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          //"sharedMap" | "alphaMap" | "aoMap" | "envMap" | "lightMap" | "map"
          "sharedMap": {
              "texture": "", // require('PATH') | "sharedMap" | "globalEnvMap"
              "channel": 0,
              "flipY": false,
              "generateMipmaps": true,
              "minFilter": 1008, //1003:NearestFilter | 1004:NearestMipmapNearestFilter | 1005:NearestMipmapLinearFilter | 1006:LinearFilter | 1007:LinearMipmapNearestFilter | 1008:LinearMipmapLinearFilter
              "magFilter": 1008,
              "anisotropy": 1, //1, 2, 4, 8, 16.... -1 for maximun supported
              "repeat": {"x": 0,"y": 0},
          },
          "aoMapIntensity": 1,
          "lightMapIntensity": 1,
        },
        "STANDARD_DEFAULT":{
          "type": "standard",
          "enable": false,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          //"sharedMap" | "alphaMap" | "aoMap" | "emissiveMap" | "envMap" | "lightMap" | "map" | "metalnessMap" | "normalMap" | "roughnessMap"
          "sharedMap": {
              "texture": "", //require('PATH') | "sharedMap" | "globalEnvMap"
              "channel": 0,
              "flipY": false,
              "generateMipmaps": true,
              "minFilter": 1008, //1003:NearestFilter | 1004:NearestMipmapNearestFilter | 1005:NearestMipmapLinearFilter | 1006:LinearFilter | 1007:LinearMipmapNearestFilter | 1008:LinearMipmapLinearFilter
              "magFilter": 1008,
              "anisotropy": 1, //1, 2, 4, 8, 16.... -1 for maximun supported
              "repeat": {"x": 0,"y": 0},
          },
          "aoMapIntensity": 1,
          "emissive": 0xFFFFFF,
          "emissiveIntensity": 1,
          "envMapIntensity": 1,
          "lightMapIntensity": 1,
          "metalness": 0,
          "roughness": 1,
          "normalScale": {"x": 1,"y": -1},

          //Updates
          "realTimeEnvironment": false,
          "lightsOnTransition": {
            "updateAt": "start", // "start" | "end" | "transition"
            "emissiveIntensity": 1,
            "envMapIntensity": 1,
            "opacity": 1,
            "color": 0xFFFFFF,
            "emissive": 0xFFFFFF,
          },
          "lightsOffTransition": {
            "updateAt": "start", // "start" | "end" | "transition"
            "emissiveIntensity": 1,
            "envMapIntensity": 1,
            "opacity": 1,
            "color": 0xFFFFFF,
            "emissive": 0xFFFFFF,
          },
        },
        "PHYSICAL_DEFAULT":{
          "type": "physical",
          "name": "",
          "enable": false,
          "color": 0xFFFFFF,
          "clearcoat": 0,
          "clearcoatRoughness": 0,
          "depthTest": true,
          "depthWrite": true,
          "transparent": false,
          "opacity": 1,
          "side": 0, //0:FrontSide | 1:BackSide | 2:DoubleSide
          "reflectivity": 0.5,
          "thickness": 0,
          "transmission": 0,

          //"sharedMap" | "alphaMap" | "aoMap" | "emissiveMap" | "envMap" | "lightMap" | "map" | "metalnessMap" | "normalMap" | "roughnessMap"
          "sharedMap": {
              "texture": "", // "" | require('PATH') | "sharedMap" | "globalEnvMap"
              "channel": 0,
              "flipY": false,
              "generateMipmaps": true,
              "minFilter": 1008, //1003:NearestFilter | 1004:NearestMipmapNearestFilter | 1005:NearestMipmapLinearFilter | 1006:LinearFilter | 1007:LinearMipmapNearestFilter | 1008:LinearMipmapLinearFilter
              "magFilter": 1008,
              "anisotropy": 1, //1, 2, 4, 8, 16.... -1 for maximun supported
              "repeat": {"x": 0,"y": 0},
          },
          "aoMapIntensity": 1,
          "emissive": 0xFFFFFF,
          "emissiveIntensity": 1,
          "envMapIntensity": 1,
          "lightMapIntensity": 1,
          "metalness": 0,
          "roughness": 1,
          "normalScale": {"x": 1,"y": -1},

          //Updates
          "realTimeEnvironment": false,
          "lightsOnTransition": {
            "updateAt": "start", // "start" | "end" | "transition"
            "emissiveIntensity": 1,
            "envMapIntensity": 1,
            "opacity": 1,
            "color": 0xFFFFFF,
            "emissive": 0xFFFFFF,
          },
          "lightsOffTransition": {
            "updateAt": "start", // "start" | "end" | "transition"
            "emissiveIntensity": 1,
            "envMapIntensity": 1,
            "opacity": 1,
            "color": 0xFFFFFF,
            "emissive": 0xFFFFFF,
          },
        },

        "BodyPaint":{
          "type": "physical",
          "name": "BodyPaint",
          "enable": true,
          "color": 0xF7F7F7,
          "clearcoat": 1,
          "clearcoatRoughness": 0,
          "depthTest": true,
          "depthWrite": true,
          "transparent": false,
          "opacity": 1,
          "side": 2,
          "reflectivity": 1,
          "thickness": 0,
          "transmission": 0,
          

          "envMap": { "texture": "globalEnvMap" },
          "envMapIntensity": 1.5,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "metalness": 0.2,
          "roughness": 0.7,

          "realTimeEnvironment": true,
        },

        "Ext_Sun_Roof":{
          "type": "physical",
          "enable": true,
          "color": 0x636363,
          "clearcoat": 0,
          "clearcoatRoughness": 0,
          "depthTest": true,
          "depthWrite": true,
          "transparent": true,
          "opacity": 0.75,
          "side": 0,
          "reflectivity": 0.1,
          "thickness": 0,
          "transmission": 1,

          "envMap": { "texture": "globalEnvMap" },
          "envMapIntensity": 3.25,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "metalness": 0,
          "roughness": 0,

          "realTimeEnvironment": true,
        },

        "Windows":{
          "type": "physical",
          "enable": true,
          "color": 0x224D62,
          "clearcoat": 0,
          "clearcoatRoughness": 0,
          "depthTest": true,
          "depthWrite": true,
          "transparent": true,
          "opacity": 0.75,
          "side": 0,
          "reflectivity": 0.5,
          "thickness": 0,
          "transmission": 1,

          "envMap": { "texture": "globalEnvMap" },
          "envMapIntensity": 5,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "metalness": 0,
          "roughness": 0,

          "realTimeEnvironment": true,
        },

        "Stitching_Cross":{
        "type": "standard",
        "enable": true,
        "color": 0x292929,
        "transparent": true,
        "opacity": 1,
        "depthTest": true,
        "depthWrite": true,

        "alphaMap": {
          "texture": require('./../../assets/IONIQ5/maps/SWStitches_d.png'),
          "channel": 0,
          "flipY": false,
          "generateMipmaps": true,
          "minFilter": 1007,
          "magFilter": 1007,
          "anisotropy": 1,
          "repeat": {"x": 1,"y": 1},
        },

        "normalMap": {
          "texture": require('./../../assets/IONIQ5/maps/SWStitches_n.png'),
          "channel": 0,
          "flipY": false,
          "generateMipmaps": true,
          "minFilter": 1007,
          "magFilter": 1007,
          "anisotropy": 1,
          "repeat": {"x": 1,"y": 1},
        },
        "normalScale": {"x": 1,"y": -1},
        "envMap": { "texture": "globalEnvMap" },

        "aoMapIntensity": 1,
        "emissive": 0x000000,
        "emissiveIntensity": 1,
        "envMapIntensity": 2,
        "lightMapIntensity": 1,
        "metalness": 0,
        "roughness": 0.65,
      },

        "Glass_Clear":{
          "type": "physical",
          "enable": true,
          "color": 0x224D62,
          "clearcoat": 0,
          "clearcoatRoughness": 0,
          "depthTest": true,
          "depthWrite": true,
          "transparent": true,
          "opacity": 0.6,
          "side": 0,
          "reflectivity": 0.1,
          "thickness": 0,
          "transmission": 1,

          "envMap": { "texture": "globalEnvMap" },
          "envMapIntensity": 2,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "metalness": 0,
          "roughness": 0,

          "realTimeEnvironment": true,
        },

        "Material_Atlas":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "sharedMap": {
              "texture": require('./../../assets/TUCSON/maps/MaterialAtlas_ORM.png'),
              "channel": 0,
              "flipY": false,
              "generateMipmaps": false,
              "minFilter": 1008,
              "magFilter": 1008,
              "anisotropy": 1,
              "repeat": {"x": 0,"y": 0},
          },
          "map": {
            "texture": require('./../../assets/TUCSON/maps/MaterialAtlas_C.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": false,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "roughnessMap": { "texture": "sharedMap" },
          "metalnessMap": { "texture": "sharedMap" },
          "aoMap": { "texture": "sharedMap" },
          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 3.1,
          "lightMapIntensity": 0,
          "metalness": 1,
          "roughness": 1,
        },

        "Material_Atlas_Int":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "sharedMap": {
              "texture": require('./../../assets/TUCSON/maps/MaterialAtlas_ORM.png'),
              "channel": 0,
              "flipY": false,
              "generateMipmaps": false,
              "minFilter": 1008,
              "magFilter": 1008,
              "anisotropy": 1,
              "repeat": {"x": 0,"y": 0},
          },
          "map": {
            "texture": require('./../../assets/TUCSON/maps/MaterialAtlas_C.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": false,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "roughnessMap": { "texture": "sharedMap" },
          "metalnessMap": { "texture": "sharedMap" },
          "aoMap": { "texture": "sharedMap" },
          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 1.5,
          "lightMapIntensity": 0,
          "metalness": 1,
          "roughness": 1,
        },

        "EmissiveRed":{
          "type": "standard",
          "enable": true,
          "color": 0xA8A8A8,
          "transparent": false,
          "opacity": 0,
          "depthTest": true,
          "depthWrite": true,

          "aoMapIntensity": 1,
          "emissive": 0xA8A8A8,
          "emissiveIntensity": 1.8,
          "envMapIntensity": 3.5,
          "lightMapIntensity": 0,
          "metalness": 1,
          "roughness": 1,

          "lightsOffTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 12.0,
            "envMapIntensity": 1.8,
            "opacity": 1,
            "emissive": 0xE5AC08,
          },
          "lightsOnTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 0,
            "envMapIntensity": 1.8,
            "opacity": 1,
            "emissive": 0xE5AC08,
          },
          
        },

        "EmissiveYellow":{
          "type": "standard",
          "enable": true,
          "color": 0xC9C9C9,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/Reflector_N.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },

          "aoMapIntensity": 1,
          "emissive": 0xE5AC08,
          "emissiveIntensity": 0,
          "envMapIntensity": 1.8,
          "lightMapIntensity": 0,
          "metalness": 1,
          "roughness": 0.15,

          "lightsOffTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 5.0,
            "envMapIntensity": 1.8,
            "opacity": 1,
            "emissive": 0xE5AC08,
          },
          "lightsOnTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 0,
            "envMapIntensity": 1.8,
            "opacity": 1,
            "emissive": 0xE5AC08,
          },
        },

        "EmissiveGray":{
          "type": "standard",
          "enable": true,
          "color": 0x737373,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "aoMapIntensity": 1,
          "emissive": 0x737373,
          "emissiveIntensity": 2,
          "envMapIntensity": 2,
          "lightMapIntensity": 0,
          "metalness": 1,
          "roughness": 1,
        },

        "SilverReflectorOLD":{
          "type": "standard",
          "enable": true,
          "color": 0xC90005,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/Image_10.jpg'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": false,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 2,
          "lightMapIntensity": 0,
          "metalness": 0.5,
          "roughness": 0.15,
        },

        "SilverReflector":{
          "type": "standard",
          "enable": true,
          "color": 0xC90005,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/Image_10.jpg'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": false,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 2,
          "lightMapIntensity": 0,
          "metalness": 0.5,
          "roughness": 0.15,

          "lightsOffTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 0.6,
            "envMapIntensity": 2,
            "opacity": 1,
            "emissive": 0xF30000,
          },
          "lightsOnTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 1,
            "envMapIntensity": 2,
            "opacity": 1,
            "emissive": 0x000000,
          },

          "realTimeEnvironment": true,
        },

        "EmissiveWhite2":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/Reflector_N.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": false,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },
          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 1,
          "lightMapIntensity": 1,
          "metalness": 1,
          "roughness": 0.1,

          "lightsOffTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 2,
            "envMapIntensity": 1,
            "opacity": 1,
            "emissive": 0xFFFFFF,
          },
          "lightsOnTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 1,
            "envMapIntensity": 1,
            "opacity": 1,
            "emissive": 0x000000,
          },
        },

        "EmissiveWhite":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/Reflector_N.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": false,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },
          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 1,
          "lightMapIntensity": 1,
          "metalness": 1,
          "roughness": 0.1,

          "lightsOffTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 5,
            "envMapIntensity": 1,
            "opacity": 1,
            "emissive": 0xFFFFFF,
          },
          "lightsOnTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 1,
            "envMapIntensity": 1,
            "opacity": 1,
            "emissive": 0x000000,
          },
        },

        "EmissiveDark":{
          "type": "standard",
          "enable": true,
          "color": 0x4A4A4A,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/Reflector_N.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": false,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },
          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 1,
          "lightMapIntensity": 1,
          "metalness": 1,
          "roughness": 0.1,
        },

        "GlassRed":{
          "type": "physical",
          "enable": true,
          "color": 0xCD0000,
          "clearcoat": 0,
          "clearcoatRoughness": 0,
          "depthTest": true,
          "depthWrite": true,
          "transparent": true,
          "opacity": 0.0,
          "side": 0,
          "reflectivity": 0.1,
          "thickness": 0,
          "transmission": 1,

          "envMapIntensity": 2,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "metalness": 0,
          "roughness": 0,

          "lightsOffTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 9.3,
            "envMapIntensity": 1,
            "opacity": 1,
            "emissive": 0xF30000,
          },
          "lightsOnTransition": {
            "updateAt": "transition", 
            "emissiveIntensity": 1,
            "envMapIntensity": 2,
            "opacity": 0,
            "emissive": 0x000000,
          },

          "realTimeEnvironment": true,
        },

        "GlassReflector":{
          "type": "physical",
          "enable": true,
          "color": 0xBABABA,
          "clearcoat": 1,
          "clearcoatRoughness": 0,
          "depthTest": true,
          "depthWrite": true,
          "transparent": true,
          "opacity": 0.5,
          "side": 0,
          "reflectivity": 0.1,
          "thickness": 0,
          "transmission": 1,

          "envMapIntensity": 6,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "metalness": 0,
          "roughness": 0,

          "realTimeEnvironment": true,
        },

        "GlassReflectorInt":{
          "type": "physical",
          "enable": true,
          "color": 0xFFFFFF,
          "clearcoat": 1,
          "clearcoatRoughness": 0,
          "depthTest": true,
          "depthWrite": false,
          "transparent": true,
          "opacity": 0.8,
          "side": 0,
          "reflectivity": 0.1,
          "thickness": 0,
          "transmission": 1,

          "envMapIntensity": 3,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "metalness": 0,
          "roughness": 0,

          "realTimeEnvironment": true,
        },

        "DashPlastic":{
          "type": "standard",
          "enable": true,
          "color": 0x292929,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/Image_10.jpg'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },
          "normalScale": {"x": 0.7,"y": -0.7},

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 7,
          "lightMapIntensity": 0,
          "metalness": 0.5,
          "roughness": 0.375,
        },

        "Leather_Rough":{
          "type": "standard",
          "enable": true,
          "color": 0x333333,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/BPE6C3_n.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },
          "normalScale": {"x": 1,"y": -1},

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 4.5,
          "lightMapIntensity": 0,
          "metalness": 0.75,
          "roughness": 0.4,
        },

        "Leather_Rough_White":{
          "type": "standard",
          "enable": true,
          "color": 0xE8E8E7,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/BPE6C3_n.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },
          "normalScale": {"x": 1,"y": -1},

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 1.6,
          "lightMapIntensity": 0,
          "metalness": 0.35,
          "roughness": 0.5,
        },

        "Leather_Rough_Dots":{
          "type": "standard",
          "enable": true,
          "color": 0x8E8E8E,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "map": {
            "texture": require('./../../assets/TUCSON/maps/YVA69T_d.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },
          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/BPE6C3_n.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0.5,"y": 0.5},
          },
          "normalScale": {"x": 0.5,"y": -0.5},

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 5.2,
          "lightMapIntensity": 0,
          "metalness": 0.75,
          "roughness": 0.425,
        },

        "UpperUpholstery":{
          "type": "standard",
          "enable": true,
          "color": 0xEBEAE8,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,


          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/BPE6C4_n.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },
          "normalScale": {"x": 1,"y": -1},

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 1,
          "lightMapIntensity": 0,
          "metalness": 0,
          "roughness": 0.75,
        },

        "Pillars":{
          "type": "standard",
          "enable": true,
          "color": 0xD8D8D8,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/TPDRN3_n.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },
          "normalScale": {"x": 1.2,"y": -1.2},

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 1,
          "lightMapIntensity": 0,
          "metalness": 0,
          "roughness": 0.9,
        },

        "Carpet":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "map": {
            "texture": require('./../../assets/TUCSON/maps/TFBCA9_d.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0.6,"y": 0.6},
          },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 0.5,
          "lightMapIntensity": 0,
          "metalness": 0,
          "roughness": 1,
        },

        "Leather_Smooth":{
          "type": "standard",
          "enable": true,
          "color": 0x414141,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/BPE6C3_n.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0.3,"y": 0.3},
          },
          "normalScale": {"x": 1,"y": -1},

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 3.5,
          "lightMapIntensity": 0,
          "metalness": 0.6,
          "roughness": 0.32,
        },

        "Roofliner":{
          "type": "standard",
          "enable": true,
          "color": 0xC5C5C5,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/TPDRN3_n.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },
          "normalScale": {"x": 0.75,"y": -0.75},

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 1,
          "lightMapIntensity": 0,
          "metalness": 0,
          "roughness": 0.85,
        },

        "RV":{
          "type": "standard",
          "enable": true,
          "color": 0x2D2D2D,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/RV.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },
          "normalScale": {"x": 0.75,"y": -0.75},

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 1,
          "lightMapIntensity": 0,
          "metalness": 0.5,
          "roughness": 0.5,
        },

        "MainBoard":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "map": {
            "texture": require('./../../assets/TUCSON/maps/2.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "emissiveMap": {
            "texture": require('./../../assets/TUCSON/maps/2.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },

          "aoMapIntensity": 1,
          "emissive": 0xFFFFFF,
          "emissiveIntensity": 0.5,
          "envMapIntensity": 1,
          "lightMapIntensity": 0,
          "metalness": 1,
          "roughness": 1,
        },

        "ClockPE":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "map": {
            "texture": require('./../../assets/TUCSON/maps/ClockPE.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "emissiveMap": {
            "texture": require('./../../assets/TUCSON/maps/ClockPE.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },

          "aoMapIntensity": 1,
          "emissive": 0xFFFFFF,
          "emissiveIntensity": 0.75,
          "envMapIntensity": 0.8,
          "lightMapIntensity": 0,
          "metalness": 1,
          "roughness": 1,
        },

        "PanelE":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "map": {
            "texture": require('./../../assets/TUCSON/maps/PanelE.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "emissiveMap": {
            "texture": require('./../../assets/TUCSON/maps/PanelE_Emissive.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },

          "aoMapIntensity": 1,
          "emissive": 0xFFFFFF,
          "emissiveIntensity": 1,
          "envMapIntensity": 1.8,
          "lightMapIntensity": 0,
          "metalness": 1,
          "roughness": 0.05,
        },

        "ScreenPanelE":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "map": {
            "texture": require('./../../assets/TUCSON/maps/1.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "emissiveMap": {
            "texture": require('./../../assets/TUCSON/maps/1.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },

          "aoMapIntensity": 1,
          "emissive": 0xFFFFFF,
          "emissiveIntensity": 0.75,
          "envMapIntensity": 0.8,
          "lightMapIntensity": 0,
          "metalness": 1,
          "roughness": 1,
        },

        "Belts":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "map": {
            "texture": require('./../../assets/TUCSON/maps/Image_9_Invert.jpg'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 4,"y": 18},
          },
          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/Image_9_Invert_nrm.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 4,"y": 18},
          },
          "normalScale": {"x": 1,"y": -1},

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 3,
          "lightMapIntensity": 0,
          "metalness": 1,
          "roughness": 1,
        },

        "B1":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "map": {
            "texture": require('./../../assets/TUCSON/maps/B1.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "emissiveMap": {
            "texture": require('./../../assets/TUCSON/maps/B1_Emissive.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/B1NM.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "normalScale": {"x": 1,"y": -1},

          "aoMapIntensity": 1,
          "emissive": 0xFFFFFF,
          "emissiveIntensity": 1,
          "envMapIntensity": 1.8,
          "lightMapIntensity": 0,
          "metalness": 1,
          "roughness": 0.05,
        },

        "StWheelPlastic":{
          "type": "standard",
          "enable": true,
          "color": 0x6A6A6A,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/Airbag.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 1,"y": 1},
          },
          "normalScale": {"x": 1,"y": -1},

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 2.5,
          "lightMapIntensity": 0,
          "metalness": 0.4,
          "roughness": 0.35,
        },

        "ShadowCaps":{
          "type": "standard",
          "enable": true,
          "color": 0x000000,
          "transparent": true,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "alphaMap": {
            "texture": require('./../../assets/TUCSON/maps/AOTires_Invert.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 2,
          "lightMapIntensity": 0,
          "metalness": 1,
          "roughness": 1,
        },

        "Tire":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "sharedMap": {
            "texture": require('./../../assets/TUCSON/maps/Image_35_Invert.png'),
            "channel": 1,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "map": {
            "texture": require('./../../assets/TUCSON/maps/Image_33_Invert.jpg'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/Image_34_Invert.jpg'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "aoMap": { "texture": "sharedMap" },
          "lightMap": { "texture": "sharedMap" },
          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 3.55,
          "lightMapIntensity": 2,
          "metalness": 0.85,
          "roughness": 0.40,
        },

        "Rin":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": true,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,

          "sharedMap": {
            "texture": require('./../../assets/TUCSON/maps/Rin_ORM.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},

          },
          "map": {
            "texture": require('./../../assets/TUCSON/maps/Rin_Diffuse_Invert.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "alphaMap": {
            "texture": require('./../../assets/TUCSON/maps/Rin_Alpha_Invert.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/Rin_Normal_Invert.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "roughnessMap": { "texture": "sharedMap" },
          "metalnessMap": { "texture": "sharedMap" },
          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 3.5,
          "lightMapIntensity": 0.1,
          "metalness": 1,
          "roughness": 1,
          "normalScale": {"x": 0.4,"y": -0.4},
          "realTimeEnvironment": true,
        },

        "RinShadow":{
          "type": "standard",
          "enable": true,
          "color": 0x000000,
          "transparent": true,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": false,

          "alphaMap": {
            "texture": require('./../../assets/TUCSON/maps/Rin_Alpha_Invert.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },

          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 0.5,
          "lightMapIntensity": 0.5,
          "metalness": 1,
          "roughness": 1,

          "realTimeEnvironment": true,
        },

        "FrontGrill":{
          "type": "standard",
          "enable": true,
          "color": 0x989898,
          "transparent": true,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,
          
          "alphaMap": {
            "texture": require('./../../assets/TUCSON/maps/MeshFrontalA.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/MeshFrontalVNM.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 1,
          "lightMapIntensity": 0.5,
          "metalness": 1,
          "roughness": 0.35,
        },

        "FrontGrid":{
          "type": "standard",
          "enable": true,
          "color": 0x989898,
          "transparent": true,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,
          
          "alphaMap": {
            "texture": require('./../../assets/TUCSON/maps/ExtPanoramicMeshA.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/ExtPanoramicMeshNM.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1008,
            "magFilter": 1008,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 1,
          "lightMapIntensity": 0.5,
          "metalness": 1,
          "roughness": 0.35,
        },

        "Speakers":{
          "type": "standard",
          "enable": true,
          "color": 0x000000,
          "transparent": true,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,
          
          "alphaMap": {
            "texture": require('./../../assets/TUCSON/maps/DoorMesh_Alpha.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "normalMap": {
            "texture": require('./../../assets/TUCSON/maps/DoorMeshNM.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 1,
          "lightMapIntensity": 1,
          "metalness": 1,
          "roughness": 0.85,
        },

        "Placa":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": false,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": true,
          
          "map": {
            "texture": require('./../../assets/TUCSON/maps/Placa.jpg'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": false,
            "minFilter": 1007,
            "magFilter": 1007,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },

          "envMap": { "texture": "globalEnvMap" },

          "aoMapIntensity": 1,
          "emissive": 0x000000,
          "emissiveIntensity": 1,
          "envMapIntensity": 1,
          "lightMapIntensity": 1,
          "metalness": 0,
          "roughness": 0.5,
        },


        "M_Ground_Shadow":{
          "type": "basic",
          "enable": true,
          "color": 0x000000,
          "reflectivity": 1,
          "transparent": true,
          "opacity": 1,
          "depthTest": true,
          "depthWrite": false,

          "alphaMap": {
              "texture": require('./../../assets/IONIQ5/maps/Shadow Cross Sport 2021_Invert.png'),
              "channel": 0,
              "flipY": false,
              "generateMipmaps": true,
              "minFilter": 1008,
              "magFilter": 1008,
              "anisotropy": 1,
              "repeat": {"x": 0,"y": 0},
          },
          "aoMapIntensity": 1,
          "lightMapIntensity": 1,
        },

        "M_LightBeams":{
          "type": "standard",
          "enable": true,
          "color": 0xFFFFFF,
          "transparent": true,
          "opacity": 0,
          "depthTest": true,
          "depthWrite": false,

          "sharedMap": {
            "texture": require('./../../assets/TUCSON/maps/LightBeams.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1003,
            "magFilter": 1003,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "alphaMap": {
            "texture": require('./../../assets/TUCSON/maps/LightBeams_Invert.png'),
            "channel": 0,
            "flipY": false,
            "generateMipmaps": true,
            "minFilter": 1003,
            "magFilter": 1003,
            "anisotropy": 1,
            "repeat": {"x": 0,"y": 0},
          },
          "map": { "texture": "sharedMap" },
          "emissiveMap": { "texture": "sharedMap" },

          "aoMapIntensity": 1,
          "emissive": 0xFFFFFF,
          "emissiveIntensity": 5,
          "envMapIntensity": 2,
          "lightMapIntensity": 0.0,
          "metalness": 0,
          "roughness": 1,

          "lightsOffTransition": {
            "updateAt": "end", 
            "emissiveIntensity": 2,
            "envMapIntensity": 1,
            "opacity": 0.4,
          },
          "lightsOnTransition": {
            "updateAt": "start", 
            "emissiveIntensity": 5,
            "envMapIntensity": 2,
            "opacity": 0,
          },
        },

      }
    }
  }
}